'use client';
import React from 'react';
import ParallaxText from '@components/ParallaxText';
import { Box, Link, List, ListItem, Stack } from '@mui/material';
import ParallaxBlock from '@components/ParallaxBlock';
import DynamicLogo from '@components/DynamicLogo';
import WharfSocial from '../WharfSocial';
import { Desktop } from '@components/Desktop';
import { Mobile } from '@components/Mobile';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';

export default function WharfFooter(props: any) {
  const footerLogo = props?.images?.ransome_wharf_lsq_logo_light;
  const footerNavigation =
    props?.locale?.section?.ransomFooterNavigation?.flat() ?? [];

  return (
    <Stack component="footer" className={cn.WharfFooterWrapper}>
      <Box className={cn.wharfFooterInner}>
        <Box className={cn.wharfFooterBlock}>
          <Box className={cn.wharfFooterMenu}>
            <List className={cn.footerNavigationList}>
              {footerNavigation.map((item: any, index: number) => (
                <ListItem key={index}>
                  <Link
                    href={item.href}
                    className={cn.wharfNavigationLink}
                    target="_blank" rel="noopener noreferrer"
                  >
                    {item.label}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>
          <Box className={cn.wharfFooterCenter}>
            <Box className={cn.wharfFooterLogo}>
              <Box className={cn.wharfFooterElement}>
                <ParallaxBlock animationType="zoomIn" animationDuration={500}>
                  <DynamicLogo
                    logoImage={footerLogo?.src}
                    alt={footerLogo?.alt || 'Ransome Wharf Logo'}
                  />
                </ParallaxBlock>
              </Box>
            </Box>
            <Desktop>
              <Box className={cn.wharfFooterOnline}>
                <WharfSocial images={props.images} />
              </Box>
            </Desktop>
          </Box>
          <Box className={cn.wharfFooterContact}>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(props.locale.section.ransomFooterContact)}
            </ParallaxText>
            <ParallaxText
              variant="p"
              animationType="slideInBottom"
              animationDuration={500}
            >
              {ReactHtmlParser(props.locale.section.ransomFooterDeveloped)}
            </ParallaxText>
          </Box>
          <Mobile>
            <Box className={cn.wharfFooterOnline}>
              <WharfSocial images={props.images} />
            </Box>
          </Mobile>
        </Box>
      </Box>
    </Stack>
  );
}
